import { BASE_URL } from "@/constants/endpoints";
import { createAxiosWithAuth } from "@/utils/axios-config";
import { objectToQueryStringWithArray } from "@/utils/query-string";
import { AxiosInstance } from "axios";

let ApiPromise: Promise<AxiosInstance> | null = null;

const getApi = async (): Promise<AxiosInstance | null> => {
  if (ApiPromise) return ApiPromise;
  ApiPromise = createAxiosWithAuth(BASE_URL, "jwt");
  return ApiPromise;
};

export interface GetEstablishmentFieldRequestsProps {
  Estados?: number[];
  CuentaOrigen?: number;
  TipoOperacion?: number;
  Fecha?: string;
  "P.Pagina": number;
  "P.Records": number;
}

export interface EstablishmentFieldRequestItem {
  id: number;
  fecha: string;
  titularCuenta: string;
  tipoOperacion: string;
  tipoOperacionId: number;
  idTipoSolicitud: number
  nombreLote: string;
  establecimiento: string;
  estado: string;
}

export interface EstablishmentFieldRequestsListResponse {
  totalPages: number;
  totalRecords: number;
  listado: EstablishmentFieldRequestItem[];
}

import { EstablishmentLote } from "@/services/establishments.service";

interface PolygonData {
  puntos: { latitud: number; longitud: number }[];
}

export interface EstablishmentFieldRequestDetail {
  id: number;
  idTipoSolicitud: number;
  tipoOperacion: string;
  tipoOperacionId: number;
  nombreLote: string;
  fecha: string;
  titularCuenta: string;
  establecimiento: string;
  tipoEstablecimiento: string;
  estado: string;
  coordenadasPoligono: PolygonData;
  poligonosEstablecimiento: PolygonData | EstablishmentLote[];
  latitud: number;
  longitud: number;
  haySolicitudesPendientes: boolean;
  motivoRechazo: string;
  fechaRechazo: string;
  usuarioRechaza: string
  hectareas?: number;
}

export const getEstablishmentFieldRequestDetail = async (
  id: string | number,
): Promise<EstablishmentFieldRequestDetail | null> => {
  const api = await getApi();
  if (!api) return null;
  const response = await api.get(`/SolicitudesEstablecimiento/${id}`);
  return response.data;
};

export interface PatchEstablishmentFieldRequestBody {
  id: number;
  idEstado: number;
  tipoEstablecimiento?: number;
  motivoRechazo?: string;
}

export const patchEstablishmentFieldRequest = async (
  id: number,
  body: PatchEstablishmentFieldRequestBody,
): Promise<void> => {
  const api = await getApi();
  if (!api) return;
  await api.patch(`/SolicitudesEstablecimiento/${id}`, body);
};

export const getEstablishmentFieldRequests = async (
  props: GetEstablishmentFieldRequestsProps,
): Promise<EstablishmentFieldRequestsListResponse | null> => {
  const api = await getApi();
  if (!api) return null;
  const response = await api.get(
    `/SolicitudesEstablecimiento?${objectToQueryStringWithArray(props)}`,
  );
  return response.data;
};
